<template>
  <v-app>
    <router-view />
    <ErrorModal v-if="errorAlert" />
    <BeforeLogoutModal />
    <p class="app-version-text">
      {{ appVersion }}
    </p>
    <div
      v-if="testCafe"
      class="testcafe-bar"
    >
      Tryb Testcafe
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
// @ts-ignore
import { useStore } from '@/store';
// @ts-ignore
import ErrorModal from '@/components/widgets/ErrorModal.vue';
// @ts-ignore
import BeforeLogoutModal from '@/components/widgets/BeforeLogoutModal.vue';
// @ts-ignore
import { isTestcafeEnabled, isTestcafeAuthEnabled } from '@/utils/testCafe';

const errorAlert = ref(false);
const testCafe = computed<boolean>(() => isTestcafeEnabled() || isTestcafeAuthEnabled());
const store = useStore();

const appVersion = computed(() => process.env.APP_VERSION);

watch(
    () => store.getters.getErrors,
    () => {
        errorAlert.value = true;
    }
);

store.dispatch('checkLogin');

</script>
<style lang="scss">
.app-version-text {
  position: fixed;
  right: 0;
  bottom: 0;
  margin: 5px;
  font-size: 12px;
  color: #333;
}
</style>
